export const miscTailHc = {
  maquetaCreateNav: {
    guidesAria: "أدلة الفيديو والمساعدة",
    guidesTip: "الأدلة والمساعدة",
    availabilityPricesTitle: "التوفّر والأسعار",
    hotelCalendarSubtitle: "التوفّر والحجوزات حسب الغرفة",
    availabilityPricesSubtitle: "الأسعار والتوفّر والحد الأدنى للإقامة",
  },
  maquetaNav: {
    guidesAria: "أدلة الفيديو والمساعدة",
    guidesTip: "الأدلة والمساعدة",
    novedadesAria: "مستجدات النظام",
    novedadesTip: "المستجدات",
    tourTip: "الجديد: جولة إرشادية",
    tourAria: "فتح جولة الجديد",
    backToPanel: "العودة إلى اللوحة",
    accountTitle: "إعدادات الحساب",
    agentIaTitle: "وكيل الذكاء الاصطناعي",
    directBookingsTitle: "الحجوزات المباشرة",
    listingsTitle: "إعدادات الإعلانات",
  },
  navMovil: {
    menuTitle: "القائمة",
    home: "الرئيسية",
    calendar: "التقويم",
    reservations: "الحجوزات",
    checkins: "تسجيلات الوصول",
    housekeeping: "التنظيف",
    channels: "قنوات الحجز",
    settings: "الإعدادات",
    settingsDesktopOnly: "متاح فقط في إصدار سطح المكتب",
    experiences: "التجارب",
  },
  register: {
    terms: "اللائحة",
    privacy: "سياسة الخصوصية",
    loginError: "حدث خطأ أثناء تسجيل الدخول.",
  },
  buttonSave: {
    savingRoom: "جارٍ حفظ الغرفة...",
  },
  firstForm: {
    name: "الاسم",
    phone: "الهاتف",
  },
  final: {
    guestsRegistered: "النزلاء المسجّلون",
    registrationsCompleted: "التسجيلات المكتملة",
    registrationTime: "وقت التسجيل: ",
    shareRegistrationLink: "مشاركة رابط التسجيل",
  },
  scannerPdf417: {
    captureCode: "التقاط الرمز",
    focusInstruction: "ركّز والتقط الرمز الشريطي لبطاقة هويتك",
  },
  configNotifications: {
    title: "الإشعارات",
    propertyLabel: "العقار",
    phoneInstruction: "أدخل رقم الهاتف الذي تريد استخدامه لتلقّي إشعارات طلبات الخدمة أو تسجيلات الوصول التي يجريها النزلاء عبر واتساب",
    saveWhatsapp: "حفظ واتساب",
    editWhatsapp: "تعديل واتساب",
    configTitle: "الإعدادات",
    serviceNotifications: "إشعارات الخدمات",
    checkinNotifications: "إشعارات تسجيل الوصول",
    active: "مُفعّلة",
    inactive: "معطّلة",
    whatsappRequired: "يجب إدخال رقم واتساب",
    swalTitle: "واتساب لإشعارات عقارك",
    swalText: "ستتلقّى جميع إشعارات الخدمات المطلوبة وتسجيلات وصول النزلاء ",
    cancel: "إلغاء",
    whatsappAdded: "تمت إضافة واتساب بنجاح",
  },
  modalPoliceData: {
    headerSub: "أدخل بيانات الدخول إلى النظام",
    closeAria: "إغلاق",
    entityName: "اسم الجهة",
    usernamePlaceholder: "أدخل اسم المستخدم",
    passwordPlaceholder: "أدخل كلمة المرور",
    hide: "إخفاء",
    show: "إظهار",
    lessorExample: "مثال: 12345",
    establishmentExample: "مثال: 67890",
    saving: "جارٍ الحفظ…",
    listingNotFound: "لم يتم العثور على الإعلان المرتبط.",
    saveFailed: "تعذّر حفظ SES Hospedajes.",
  },
  notificaciones: {
    title: "الإشعارات",
    propertyLabel: "العقار",
    phoneInstruction: "أدخل رقم الهاتف الذي تريد استخدامه لتلقّي إشعارات طلبات الخدمة أو تسجيلات الوصول التي يجريها النزلاء عبر واتساب",
    saveWhatsapp: "حفظ واتساب",
    editWhatsapp: "تعديل واتساب",
    configTitle: "الإعدادات",
    serviceNotifications: "إشعارات الخدمات",
    checkinNotifications: "إشعارات تسجيل الوصول",
    active: "مُفعّلة",
    inactive: "معطّلة",
    whatsappRequired: "يجب إدخال رقم واتساب",
    swalTitle: "واتساب لإشعارات عقارك",
    swalText: "ستتلقّى جميع إشعارات الخدمات المطلوبة وتسجيلات وصول النزلاء ",
    cancel: "إلغاء",
    whatsappAdded: "تمت إضافة واتساب بنجاح",
  },
  admins: {
    listTitle: "قائمة المديرين",
    newManager: "مدير جديد",
    today: "اليوم",
    thName: "الاسم",
    thEmail: "البريد الإلكتروني",
    thRegistered: "تاريخ التسجيل",
    edit: "تعديل",
    delete: "حذف",
    userLabel: "اسم المستخدم",
    emailLabel: "البريد الإلكتروني",
    passwordLabel: "كلمة المرور",
    cancel: "إلغاء",
    save: "حفظ",
    createdOk: "تم الإنشاء بنجاح",
    requestError: "خطأ في الطلب",
    updatedOk: "تم التحديث بنجاح",
    deletedOk: "تم الحذف بنجاح",
  },
};
